module.exports = __webpack_public_path__ + "static/media/sedative.16ba9afd.png";